/* eslint-disable jsx-a11y/no-static-element-interactions */
import { LayoutList, MessageSquareDot, PanelLeftClose } from 'lucide-react';
import React from 'react';
import { iconStyle, links, parentIconStyle, TAB_INDEXES } from './constants';

const SidebarButtons = [
  {
    key: 'reportIssue',
    icon: <MessageSquareDot size={22} className={iconStyle} />,
    label: 'Report an Issue',
    action: (handleCloseActionView, openActiveActionDetails) => {
      handleCloseActionView();
      openActiveActionDetails(
        links[TAB_INDEXES.REPORT_ISSUE],
        TAB_INDEXES.REPORT_ISSUE,
      );
    },
  },
  {
    key: 'quickActions',
    icon: <LayoutList size={22} className={iconStyle} />,
    label: 'Quick Actions',
    action: (handleCloseActionView, openActiveActionDetails) => {
      handleCloseActionView();
      openActiveActionDetails(
        links[TAB_INDEXES.QUICK_ACTION],
        TAB_INDEXES.QUICK_ACTION,
      );
    },
  },
];

const SidebarUI = ({ handleCloseActionView, openActiveActionDetails }) => {
  return (
    <div className='tw-flex tw-flex-col tw-items-center'>
      {/* Sidebar close button */}
      <div className='tw-py-[1.6rem] tw-w-full tw-flex tw-justify-center'>
        <div
          className='tw-group tw-h-[45px] tw-flex tw-items-center tw-justify-center tw-aspect-square tw-w-[45px] tw-rounded-xl tw-bg-white tw-border tw-border-solid tw-border-zinc-300 tw-transition-all tw-duration-200 tw-ease-in-out tw-cursor-pointer hover:tw-opacity-90'
          onClick={handleCloseActionView}
        >
          <PanelLeftClose size={22} className={iconStyle} strokeWidth={1.7} />
        </div>
      </div>

      {/* Divider */}
      <div className='tw-h-px tw-w-full tw-bg-zinc-200/80' />

      {/* Sidebar Buttons */}
      {SidebarButtons.map((button) => (
        <div
          key={button.key}
          className='tw-pt-[1.6rem] tw-w-full tw-flex tw-justify-center tw-relative tw-group'
        >
          <div
            className={`${
              button.key === 'reportIssue'
                ? 'tw-left-[-160%]'
                : 'tw-left-[-145%]'
            } tw-absolute tw-top-[40%] tw-z-50
tw-bg-white tw-text-base-green tw-text-sm tw-border tw-border-base-green
tw-font-medium tw-px-3 tw-py-1.5 tw-rounded-md tw-shadow-md
tw-opacity-0 group-hover:tw-opacity-100 tw-scale-95 group-hover:tw-scale-100
tw-transition-all tw-duration-200 tw-ease-in-out tw-pointer-events-none`}
          >
            {button.label}
          </div>
          <div
            className={parentIconStyle}
            onClick={() =>
              button.action(handleCloseActionView, openActiveActionDetails)
            }
          >
            {button.icon}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SidebarUI;
